import { PropsWithChildren } from "react";
import { Box, SxProps, Theme } from "@mui/material";

interface DraggingBoxProps {
  sx?: SxProps<Theme> | undefined;
}
export function DraggingBox({ sx, children }: PropsWithChildren<DraggingBoxProps>) {
  return <Box sx={{ ...sx, position: "fixed", top: 0, left: 0, pointerEvents: "none", zIndex: 5000 }}>{children}</Box>;
}
